import React from 'react';
import { BookOpenIcon, WrenchScrewdriverIcon, BookmarkIcon } from '@heroicons/react/24/outline';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import PlaybookCard from '../../../components/playbooks/PlaybookCard';
import ResourceList from '../../../components/playbooks/ResourceList';

const tools = [
  {
    title: 'TeamRetro',
    description: 'If you don\'t want to use a Miro board and would rather a product for easier reporting and automations, I can recommend TeamRetro.',
    url: 'https://www.teamretro.com/health-checks/team-health-check'
  },
  {
    title: 'Squad Health Check Template | Miroverse',
    url: 'https://miro.com/miroverse/squad-health-check/'
  },
  {
    title: 'Team Health Check Template | Miroverse',
    url: 'https://miro.com/miroverse/team-health-check/'
  }
];

const additional = [
  {
    title: 'Miroverse Template: Squad Health Check – Flow Focused',
    url: 'https://malcolmbastien.com/2023/05/11/miroverse-template-squad-health-check/'
  },
  {
    title: 'Tanzu Labs Team Health Check Template | Miroverse',
    url: 'https://miro.com/miroverse/team-health-check-template/'
  }
];

const TeamHealthChecksUsefulResources = () => (
  <div className="space-y-8">
    <PlaybookSection title="Useful Resources" icon={<BookOpenIcon className="h-7 w-7 text-primary-light" />} heading>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <PlaybookCard>
          <ResourceList 
            title="Tools & Templates" 
            items={tools} 
            icon={WrenchScrewdriverIcon}
          />
        </PlaybookCard>
        <PlaybookCard>
          <ResourceList 
            title="Additional Resources" 
            items={additional} 
            icon={BookmarkIcon}
          />
        </PlaybookCard>
      </div>
    </PlaybookSection>
  </div>
);

export default TeamHealthChecksUsefulResources; 